module.exports = __webpack_public_path__ + "static/media/Milex-Cube-Pessary-Instructions-for-Use.13510efc.jpg";